// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file types.proto (package types, edition 2023)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file types.proto.
 */
export const file_types: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * Common types used across services
 *
 * @generated from message types.ID
 */
export type ID = Message<"types.ID"> & {
  /**
   * @generated from field: string value = 1;
   */
  value: string;
};

/**
 * Describes the message types.ID.
 * Use `create(IDSchema)` to create a new message.
 */
export const IDSchema: GenMessage<ID> = /*@__PURE__*/
  messageDesc(file_types, 0);

/**
 * @generated from message types.Address
 */
export type Address = Message<"types.Address"> & {
  /**
   * @generated from field: types.AddressType address_type = 1;
   */
  addressType: AddressType;

  /**
   * @generated from field: string street_address = 2;
   */
  streetAddress: string;

  /**
   * @generated from field: string city = 3;
   */
  city: string;

  /**
   * @generated from field: string state = 4;
   */
  state: string;

  /**
   * @generated from field: string postal_code = 5;
   */
  postalCode: string;

  /**
   * @generated from field: string country = 6;
   */
  country: string;

  /**
   * @generated from field: double latitude = 7;
   */
  latitude: number;

  /**
   * @generated from field: double longitude = 8;
   */
  longitude: number;

  /**
   * @generated from field: bool is_mailing_address = 9;
   */
  isMailingAddress: boolean;

  /**
   * @generated from field: string street_address_2 = 10;
   */
  streetAddress2: string;
};

/**
 * Describes the message types.Address.
 * Use `create(AddressSchema)` to create a new message.
 */
export const AddressSchema: GenMessage<Address> = /*@__PURE__*/
  messageDesc(file_types, 1);

/**
 * @generated from message types.Timezone
 */
export type Timezone = Message<"types.Timezone"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: int32 offset = 2;
   */
  offset: number;
};

/**
 * Describes the message types.Timezone.
 * Use `create(TimezoneSchema)` to create a new message.
 */
export const TimezoneSchema: GenMessage<Timezone> = /*@__PURE__*/
  messageDesc(file_types, 2);

/**
 * @generated from message types.Money
 */
export type Money = Message<"types.Money"> & {
  /**
   * @generated from field: types.CurrencyCode currency = 1;
   */
  currency: CurrencyCode;

  /**
   * @generated from field: string amount = 2;
   */
  amount: string;
};

/**
 * Describes the message types.Money.
 * Use `create(MoneySchema)` to create a new message.
 */
export const MoneySchema: GenMessage<Money> = /*@__PURE__*/
  messageDesc(file_types, 3);

/**
 * @generated from message types.Weight
 */
export type Weight = Message<"types.Weight"> & {
  /**
   * @generated from field: string value = 1;
   */
  value: string;

  /**
   * @generated from field: types.Unit unit = 2;
   */
  unit: Unit;
};

/**
 * Describes the message types.Weight.
 * Use `create(WeightSchema)` to create a new message.
 */
export const WeightSchema: GenMessage<Weight> = /*@__PURE__*/
  messageDesc(file_types, 4);

/**
 * @generated from message types.Decimal
 */
export type Decimal = Message<"types.Decimal"> & {
  /**
   * @generated from field: string value = 1;
   */
  value: string;
};

/**
 * Describes the message types.Decimal.
 * Use `create(DecimalSchema)` to create a new message.
 */
export const DecimalSchema: GenMessage<Decimal> = /*@__PURE__*/
  messageDesc(file_types, 5);

/**
 * @generated from message types.DateRange
 */
export type DateRange = Message<"types.DateRange"> & {
  /**
   * @generated from field: google.protobuf.Timestamp start_date = 1;
   */
  startDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_date = 2;
   */
  endDate?: Timestamp;
};

/**
 * Describes the message types.DateRange.
 * Use `create(DateRangeSchema)` to create a new message.
 */
export const DateRangeSchema: GenMessage<DateRange> = /*@__PURE__*/
  messageDesc(file_types, 6);

/**
 * @generated from message types.Base
 */
export type Base = Message<"types.Base"> & {
  /**
   * @generated from field: types.ID organization_id = 1;
   */
  organizationId?: ID;

  /**
   * @generated from field: types.ID created_by = 2;
   */
  createdBy?: ID;

  /**
   * @generated from field: types.ID updated_by = 3;
   */
  updatedBy?: ID;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message types.Base.
 * Use `create(BaseSchema)` to create a new message.
 */
export const BaseSchema: GenMessage<Base> = /*@__PURE__*/
  messageDesc(file_types, 7);

/**
 * @generated from message types.Error
 */
export type Error = Message<"types.Error"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message types.Error.
 * Use `create(ErrorSchema)` to create a new message.
 */
export const ErrorSchema: GenMessage<Error> = /*@__PURE__*/
  messageDesc(file_types, 8);

/**
 * @generated from message types.Point
 */
export type Point = Message<"types.Point"> & {
  /**
   * @generated from field: double latitude = 1;
   */
  latitude: number;

  /**
   * @generated from field: double longitude = 2;
   */
  longitude: number;
};

/**
 * Describes the message types.Point.
 * Use `create(PointSchema)` to create a new message.
 */
export const PointSchema: GenMessage<Point> = /*@__PURE__*/
  messageDesc(file_types, 9);

/**
 * @generated from message types.Coordinates
 */
export type Coordinates = Message<"types.Coordinates"> & {
  /**
   * @generated from field: double latitude = 1;
   */
  latitude: number;

  /**
   * @generated from field: double longitude = 2;
   */
  longitude: number;
};

/**
 * Describes the message types.Coordinates.
 * Use `create(CoordinatesSchema)` to create a new message.
 */
export const CoordinatesSchema: GenMessage<Coordinates> = /*@__PURE__*/
  messageDesc(file_types, 10);

/**
 * @generated from message types.Polygon
 */
export type Polygon = Message<"types.Polygon"> & {
  /**
   * @generated from field: repeated types.Point points = 1;
   */
  points: Point[];
};

/**
 * Describes the message types.Polygon.
 * Use `create(PolygonSchema)` to create a new message.
 */
export const PolygonSchema: GenMessage<Polygon> = /*@__PURE__*/
  messageDesc(file_types, 11);

/**
 * @generated from message types.Pagination
 */
export type Pagination = Message<"types.Pagination"> & {
  /**
   * @generated from field: int32 offset = 1;
   */
  offset: number;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * Describes the message types.Pagination.
 * Use `create(PaginationSchema)` to create a new message.
 */
export const PaginationSchema: GenMessage<Pagination> = /*@__PURE__*/
  messageDesc(file_types, 12);

/**
 * @generated from enum types.AddressType
 */
export enum AddressType {
  /**
   * @generated from enum value: ADDRESS_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ADDRESS_TYPE_STANDARD = 1;
   */
  STANDARD = 1,

  /**
   * @generated from enum value: ADDRESS_TYPE_NON_STANDARD = 2;
   */
  NON_STANDARD = 2,

  /**
   * @generated from enum value: ADDRESS_TYPE_PO_BOX = 3;
   */
  PO_BOX = 3,
}

/**
 * Describes the enum types.AddressType.
 */
export const AddressTypeSchema: GenEnum<AddressType> = /*@__PURE__*/
  enumDesc(file_types, 0);

/**
 * @generated from enum types.CurrencyCode
 */
export enum CurrencyCode {
  /**
   * @generated from enum value: CURRENCY_CODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CURRENCY_CODE_AED = 1;
   */
  AED = 1,

  /**
   * @generated from enum value: CURRENCY_CODE_AFN = 2;
   */
  AFN = 2,

  /**
   * @generated from enum value: CURRENCY_CODE_ALL = 3;
   */
  ALL = 3,

  /**
   * @generated from enum value: CURRENCY_CODE_AMD = 4;
   */
  AMD = 4,

  /**
   * @generated from enum value: CURRENCY_CODE_ANG = 5;
   */
  ANG = 5,

  /**
   * @generated from enum value: CURRENCY_CODE_AOA = 6;
   */
  AOA = 6,

  /**
   * @generated from enum value: CURRENCY_CODE_ARS = 7;
   */
  ARS = 7,

  /**
   * @generated from enum value: CURRENCY_CODE_AUD = 8;
   */
  AUD = 8,

  /**
   * @generated from enum value: CURRENCY_CODE_AWG = 9;
   */
  AWG = 9,

  /**
   * @generated from enum value: CURRENCY_CODE_AZN = 10;
   */
  AZN = 10,

  /**
   * @generated from enum value: CURRENCY_CODE_BAM = 11;
   */
  BAM = 11,

  /**
   * @generated from enum value: CURRENCY_CODE_BBD = 12;
   */
  BBD = 12,

  /**
   * @generated from enum value: CURRENCY_CODE_BDT = 13;
   */
  BDT = 13,

  /**
   * @generated from enum value: CURRENCY_CODE_BGN = 14;
   */
  BGN = 14,

  /**
   * @generated from enum value: CURRENCY_CODE_BHD = 15;
   */
  BHD = 15,

  /**
   * @generated from enum value: CURRENCY_CODE_BIF = 16;
   */
  BIF = 16,

  /**
   * @generated from enum value: CURRENCY_CODE_BMD = 17;
   */
  BMD = 17,

  /**
   * @generated from enum value: CURRENCY_CODE_BND = 18;
   */
  BND = 18,

  /**
   * @generated from enum value: CURRENCY_CODE_BOB = 19;
   */
  BOB = 19,

  /**
   * @generated from enum value: CURRENCY_CODE_BRL = 20;
   */
  BRL = 20,

  /**
   * @generated from enum value: CURRENCY_CODE_BSD = 21;
   */
  BSD = 21,

  /**
   * @generated from enum value: CURRENCY_CODE_BTN = 22;
   */
  BTN = 22,

  /**
   * @generated from enum value: CURRENCY_CODE_BWP = 23;
   */
  BWP = 23,

  /**
   * @generated from enum value: CURRENCY_CODE_BYN = 24;
   */
  BYN = 24,

  /**
   * @generated from enum value: CURRENCY_CODE_BZD = 25;
   */
  BZD = 25,

  /**
   * @generated from enum value: CURRENCY_CODE_CAD = 26;
   */
  CAD = 26,

  /**
   * @generated from enum value: CURRENCY_CODE_CDF = 27;
   */
  CDF = 27,

  /**
   * @generated from enum value: CURRENCY_CODE_CHF = 28;
   */
  CHF = 28,

  /**
   * @generated from enum value: CURRENCY_CODE_CLP = 29;
   */
  CLP = 29,

  /**
   * @generated from enum value: CURRENCY_CODE_CNY = 30;
   */
  CNY = 30,

  /**
   * @generated from enum value: CURRENCY_CODE_COP = 31;
   */
  COP = 31,

  /**
   * @generated from enum value: CURRENCY_CODE_CRC = 32;
   */
  CRC = 32,

  /**
   * @generated from enum value: CURRENCY_CODE_CUC = 33;
   */
  CUC = 33,

  /**
   * @generated from enum value: CURRENCY_CODE_CUP = 34;
   */
  CUP = 34,

  /**
   * @generated from enum value: CURRENCY_CODE_CVE = 35;
   */
  CVE = 35,

  /**
   * @generated from enum value: CURRENCY_CODE_CZK = 36;
   */
  CZK = 36,

  /**
   * @generated from enum value: CURRENCY_CODE_DJF = 37;
   */
  DJF = 37,

  /**
   * @generated from enum value: CURRENCY_CODE_DKK = 38;
   */
  DKK = 38,

  /**
   * @generated from enum value: CURRENCY_CODE_DOP = 39;
   */
  DOP = 39,

  /**
   * @generated from enum value: CURRENCY_CODE_DZD = 40;
   */
  DZD = 40,

  /**
   * @generated from enum value: CURRENCY_CODE_EGP = 41;
   */
  EGP = 41,

  /**
   * @generated from enum value: CURRENCY_CODE_ERN = 42;
   */
  ERN = 42,

  /**
   * @generated from enum value: CURRENCY_CODE_ETB = 43;
   */
  ETB = 43,

  /**
   * @generated from enum value: CURRENCY_CODE_EUR = 44;
   */
  EUR = 44,

  /**
   * @generated from enum value: CURRENCY_CODE_FJD = 45;
   */
  FJD = 45,

  /**
   * @generated from enum value: CURRENCY_CODE_FKP = 46;
   */
  FKP = 46,

  /**
   * @generated from enum value: CURRENCY_CODE_GBP = 47;
   */
  GBP = 47,

  /**
   * @generated from enum value: CURRENCY_CODE_GEL = 48;
   */
  GEL = 48,

  /**
   * @generated from enum value: CURRENCY_CODE_GHS = 49;
   */
  GHS = 49,

  /**
   * @generated from enum value: CURRENCY_CODE_GIP = 50;
   */
  GIP = 50,

  /**
   * @generated from enum value: CURRENCY_CODE_GMD = 51;
   */
  GMD = 51,

  /**
   * @generated from enum value: CURRENCY_CODE_GNF = 52;
   */
  GNF = 52,

  /**
   * @generated from enum value: CURRENCY_CODE_GTQ = 53;
   */
  GTQ = 53,

  /**
   * @generated from enum value: CURRENCY_CODE_GYD = 54;
   */
  GYD = 54,

  /**
   * @generated from enum value: CURRENCY_CODE_HKD = 55;
   */
  HKD = 55,

  /**
   * @generated from enum value: CURRENCY_CODE_HNL = 56;
   */
  HNL = 56,

  /**
   * @generated from enum value: CURRENCY_CODE_HRK = 57;
   */
  HRK = 57,

  /**
   * @generated from enum value: CURRENCY_CODE_HTG = 58;
   */
  HTG = 58,

  /**
   * @generated from enum value: CURRENCY_CODE_HUF = 59;
   */
  HUF = 59,

  /**
   * @generated from enum value: CURRENCY_CODE_IDR = 60;
   */
  IDR = 60,

  /**
   * @generated from enum value: CURRENCY_CODE_ILS = 61;
   */
  ILS = 61,

  /**
   * @generated from enum value: CURRENCY_CODE_INR = 62;
   */
  INR = 62,

  /**
   * @generated from enum value: CURRENCY_CODE_IQD = 63;
   */
  IQD = 63,

  /**
   * @generated from enum value: CURRENCY_CODE_IRR = 64;
   */
  IRR = 64,

  /**
   * @generated from enum value: CURRENCY_CODE_ISK = 65;
   */
  ISK = 65,

  /**
   * @generated from enum value: CURRENCY_CODE_JMD = 66;
   */
  JMD = 66,

  /**
   * @generated from enum value: CURRENCY_CODE_JOD = 67;
   */
  JOD = 67,

  /**
   * @generated from enum value: CURRENCY_CODE_JPY = 68;
   */
  JPY = 68,

  /**
   * @generated from enum value: CURRENCY_CODE_KES = 69;
   */
  KES = 69,

  /**
   * @generated from enum value: CURRENCY_CODE_KGS = 70;
   */
  KGS = 70,

  /**
   * @generated from enum value: CURRENCY_CODE_KHR = 71;
   */
  KHR = 71,

  /**
   * @generated from enum value: CURRENCY_CODE_KMF = 72;
   */
  KMF = 72,

  /**
   * @generated from enum value: CURRENCY_CODE_KPW = 73;
   */
  KPW = 73,

  /**
   * @generated from enum value: CURRENCY_CODE_KRW = 74;
   */
  KRW = 74,

  /**
   * @generated from enum value: CURRENCY_CODE_KWD = 75;
   */
  KWD = 75,

  /**
   * @generated from enum value: CURRENCY_CODE_KYD = 76;
   */
  KYD = 76,

  /**
   * @generated from enum value: CURRENCY_CODE_KZT = 77;
   */
  KZT = 77,

  /**
   * @generated from enum value: CURRENCY_CODE_LAK = 78;
   */
  LAK = 78,

  /**
   * @generated from enum value: CURRENCY_CODE_LBP = 79;
   */
  LBP = 79,

  /**
   * @generated from enum value: CURRENCY_CODE_LKR = 80;
   */
  LKR = 80,

  /**
   * @generated from enum value: CURRENCY_CODE_LRD = 81;
   */
  LRD = 81,

  /**
   * @generated from enum value: CURRENCY_CODE_LSL = 82;
   */
  LSL = 82,

  /**
   * @generated from enum value: CURRENCY_CODE_LYD = 83;
   */
  LYD = 83,

  /**
   * @generated from enum value: CURRENCY_CODE_MAD = 84;
   */
  MAD = 84,

  /**
   * @generated from enum value: CURRENCY_CODE_MDL = 85;
   */
  MDL = 85,

  /**
   * @generated from enum value: CURRENCY_CODE_MGA = 86;
   */
  MGA = 86,

  /**
   * @generated from enum value: CURRENCY_CODE_MKD = 87;
   */
  MKD = 87,

  /**
   * @generated from enum value: CURRENCY_CODE_MMK = 88;
   */
  MMK = 88,

  /**
   * @generated from enum value: CURRENCY_CODE_MNT = 89;
   */
  MNT = 89,

  /**
   * @generated from enum value: CURRENCY_CODE_MOP = 90;
   */
  MOP = 90,

  /**
   * @generated from enum value: CURRENCY_CODE_MRU = 91;
   */
  MRU = 91,

  /**
   * @generated from enum value: CURRENCY_CODE_MUR = 92;
   */
  MUR = 92,

  /**
   * @generated from enum value: CURRENCY_CODE_MVR = 93;
   */
  MVR = 93,

  /**
   * @generated from enum value: CURRENCY_CODE_MWK = 94;
   */
  MWK = 94,

  /**
   * @generated from enum value: CURRENCY_CODE_MXN = 95;
   */
  MXN = 95,

  /**
   * @generated from enum value: CURRENCY_CODE_MYR = 96;
   */
  MYR = 96,

  /**
   * @generated from enum value: CURRENCY_CODE_MZN = 97;
   */
  MZN = 97,

  /**
   * @generated from enum value: CURRENCY_CODE_NAD = 98;
   */
  NAD = 98,

  /**
   * @generated from enum value: CURRENCY_CODE_NGN = 99;
   */
  NGN = 99,

  /**
   * @generated from enum value: CURRENCY_CODE_NIO = 100;
   */
  NIO = 100,

  /**
   * @generated from enum value: CURRENCY_CODE_NOK = 101;
   */
  NOK = 101,

  /**
   * @generated from enum value: CURRENCY_CODE_NPR = 102;
   */
  NPR = 102,

  /**
   * @generated from enum value: CURRENCY_CODE_NZD = 103;
   */
  NZD = 103,

  /**
   * @generated from enum value: CURRENCY_CODE_OMR = 104;
   */
  OMR = 104,

  /**
   * @generated from enum value: CURRENCY_CODE_PAB = 105;
   */
  PAB = 105,

  /**
   * @generated from enum value: CURRENCY_CODE_PEN = 106;
   */
  PEN = 106,

  /**
   * @generated from enum value: CURRENCY_CODE_PGK = 107;
   */
  PGK = 107,

  /**
   * @generated from enum value: CURRENCY_CODE_PHP = 108;
   */
  PHP = 108,

  /**
   * @generated from enum value: CURRENCY_CODE_PKR = 109;
   */
  PKR = 109,

  /**
   * @generated from enum value: CURRENCY_CODE_PLN = 110;
   */
  PLN = 110,

  /**
   * @generated from enum value: CURRENCY_CODE_PYG = 111;
   */
  PYG = 111,

  /**
   * @generated from enum value: CURRENCY_CODE_QAR = 112;
   */
  QAR = 112,

  /**
   * @generated from enum value: CURRENCY_CODE_RON = 113;
   */
  RON = 113,

  /**
   * @generated from enum value: CURRENCY_CODE_RSD = 114;
   */
  RSD = 114,

  /**
   * @generated from enum value: CURRENCY_CODE_RUB = 115;
   */
  RUB = 115,

  /**
   * @generated from enum value: CURRENCY_CODE_RWF = 116;
   */
  RWF = 116,

  /**
   * @generated from enum value: CURRENCY_CODE_SAR = 117;
   */
  SAR = 117,

  /**
   * @generated from enum value: CURRENCY_CODE_SBD = 118;
   */
  SBD = 118,

  /**
   * @generated from enum value: CURRENCY_CODE_SCR = 119;
   */
  SCR = 119,

  /**
   * @generated from enum value: CURRENCY_CODE_SDG = 120;
   */
  SDG = 120,

  /**
   * @generated from enum value: CURRENCY_CODE_SEK = 121;
   */
  SEK = 121,

  /**
   * @generated from enum value: CURRENCY_CODE_SGD = 122;
   */
  SGD = 122,

  /**
   * @generated from enum value: CURRENCY_CODE_SHP = 123;
   */
  SHP = 123,

  /**
   * @generated from enum value: CURRENCY_CODE_SLL = 124;
   */
  SLL = 124,

  /**
   * @generated from enum value: CURRENCY_CODE_SOS = 125;
   */
  SOS = 125,

  /**
   * @generated from enum value: CURRENCY_CODE_SRD = 126;
   */
  SRD = 126,

  /**
   * @generated from enum value: CURRENCY_CODE_SSP = 127;
   */
  SSP = 127,

  /**
   * @generated from enum value: CURRENCY_CODE_STN = 128;
   */
  STN = 128,

  /**
   * @generated from enum value: CURRENCY_CODE_SVC = 129;
   */
  SVC = 129,

  /**
   * @generated from enum value: CURRENCY_CODE_SYP = 130;
   */
  SYP = 130,

  /**
   * @generated from enum value: CURRENCY_CODE_SZL = 131;
   */
  SZL = 131,

  /**
   * @generated from enum value: CURRENCY_CODE_THB = 132;
   */
  THB = 132,

  /**
   * @generated from enum value: CURRENCY_CODE_TJS = 133;
   */
  TJS = 133,

  /**
   * @generated from enum value: CURRENCY_CODE_TMT = 134;
   */
  TMT = 134,

  /**
   * @generated from enum value: CURRENCY_CODE_TND = 135;
   */
  TND = 135,

  /**
   * @generated from enum value: CURRENCY_CODE_TOP = 136;
   */
  TOP = 136,

  /**
   * @generated from enum value: CURRENCY_CODE_TRY = 137;
   */
  TRY = 137,

  /**
   * @generated from enum value: CURRENCY_CODE_TTD = 138;
   */
  TTD = 138,

  /**
   * @generated from enum value: CURRENCY_CODE_TWD = 139;
   */
  TWD = 139,

  /**
   * @generated from enum value: CURRENCY_CODE_TZS = 140;
   */
  TZS = 140,

  /**
   * @generated from enum value: CURRENCY_CODE_UAH = 141;
   */
  UAH = 141,

  /**
   * @generated from enum value: CURRENCY_CODE_UGX = 142;
   */
  UGX = 142,

  /**
   * @generated from enum value: CURRENCY_CODE_USD = 143;
   */
  USD = 143,

  /**
   * @generated from enum value: CURRENCY_CODE_UYU = 144;
   */
  UYU = 144,

  /**
   * @generated from enum value: CURRENCY_CODE_UZS = 145;
   */
  UZS = 145,

  /**
   * @generated from enum value: CURRENCY_CODE_VES = 146;
   */
  VES = 146,

  /**
   * @generated from enum value: CURRENCY_CODE_VND = 147;
   */
  VND = 147,

  /**
   * @generated from enum value: CURRENCY_CODE_VUV = 148;
   */
  VUV = 148,

  /**
   * @generated from enum value: CURRENCY_CODE_WST = 149;
   */
  WST = 149,

  /**
   * @generated from enum value: CURRENCY_CODE_XAF = 150;
   */
  XAF = 150,

  /**
   * @generated from enum value: CURRENCY_CODE_XCD = 151;
   */
  XCD = 151,

  /**
   * @generated from enum value: CURRENCY_CODE_XOF = 152;
   */
  XOF = 152,

  /**
   * @generated from enum value: CURRENCY_CODE_XPF = 153;
   */
  XPF = 153,

  /**
   * @generated from enum value: CURRENCY_CODE_YER = 154;
   */
  YER = 154,

  /**
   * @generated from enum value: CURRENCY_CODE_ZAR = 155;
   */
  ZAR = 155,

  /**
   * @generated from enum value: CURRENCY_CODE_ZMW = 156;
   */
  ZMW = 156,

  /**
   * @generated from enum value: CURRENCY_CODE_ZWL = 157;
   */
  ZWL = 157,
}

/**
 * Describes the enum types.CurrencyCode.
 */
export const CurrencyCodeSchema: GenEnum<CurrencyCode> = /*@__PURE__*/
  enumDesc(file_types, 1);

/**
 * @generated from enum types.Unit
 */
export enum Unit {
  /**
   * @generated from enum value: UNIT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: UNIT_POUNDS = 1;
   */
  POUNDS = 1,

  /**
   * @generated from enum value: UNIT_NET_TONS = 2;
   */
  NET_TONS = 2,

  /**
   * @generated from enum value: UNIT_GROSS_TONS = 3;
   */
  GROSS_TONS = 3,

  /**
   * @generated from enum value: UNIT_KILOGRAMS = 4;
   */
  KILOGRAMS = 4,

  /**
   * @generated from enum value: UNIT_METRIC_TONS = 5;
   */
  METRIC_TONS = 5,

  /**
   * @generated from enum value: UNIT_SHORT_TONS = 6;
   */
  SHORT_TONS = 6,

  /**
   * @generated from enum value: UNIT_EACH = 7;
   */
  EACH = 7,

  /**
   * @generated from enum value: UNIT_SHORT_HUNDREDWEIGHT = 8;
   */
  SHORT_HUNDREDWEIGHT = 8,

  /**
   * @generated from enum value: UNIT_LONG_HUNDREDWEIGHT = 9;
   */
  LONG_HUNDREDWEIGHT = 9,

  /**
   * @generated from enum value: UNIT_YARD = 10;
   */
  YARD = 10,

  /**
   * @generated from enum value: UNIT_METER = 11;
   */
  METER = 11,
}

/**
 * Describes the enum types.Unit.
 */
export const UnitSchema: GenEnum<Unit> = /*@__PURE__*/
  enumDesc(file_types, 2);

/**
 * @generated from enum types.UnitFamily
 */
export enum UnitFamily {
  /**
   * @generated from enum value: UNIT_FAMILY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: UNIT_FAMILY_WEIGHT = 1;
   */
  WEIGHT = 1,

  /**
   * @generated from enum value: UNIT_FAMILY_COUNT = 2;
   */
  COUNT = 2,

  /**
   * @generated from enum value: UNIT_FAMILY_LENGTH = 3;
   */
  LENGTH = 3,
}

/**
 * Describes the enum types.UnitFamily.
 */
export const UnitFamilySchema: GenEnum<UnitFamily> = /*@__PURE__*/
  enumDesc(file_types, 3);

/**
 * @generated from enum types.FreightTerm
 */
export enum FreightTerm {
  /**
   * @generated from enum value: FREIGHT_TERM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Cost, Insurance, and Freight
   *
   * @generated from enum value: FREIGHT_TERM_CIF = 1;
   */
  CIF = 1,

  /**
   * Cost and Freight
   *
   * @generated from enum value: FREIGHT_TERM_CNF = 2;
   */
  CNF = 2,

  /**
   * Delivered Duty Paid
   *
   * @generated from enum value: FREIGHT_TERM_DDP = 3;
   */
  DDP = 3,

  /**
   * Free on Board
   *
   * @generated from enum value: FREIGHT_TERM_FOB = 4;
   */
  FOB = 4,

  /**
   * Ex Works
   *
   * @generated from enum value: FREIGHT_TERM_EXW = 5;
   */
  EXW = 5,

  /**
   * Free Alongside Ship
   *
   * @generated from enum value: FREIGHT_TERM_FAS = 6;
   */
  FAS = 6,

  /**
   * Picked Up
   *
   * @generated from enum value: FREIGHT_TERM_PICKED_UP = 7;
   */
  PICKED_UP = 7,

  /**
   * Delivered
   *
   * @generated from enum value: FREIGHT_TERM_DELIVERED = 8;
   */
  DELIVERED = 8,
}

/**
 * Describes the enum types.FreightTerm.
 */
export const FreightTermSchema: GenEnum<FreightTerm> = /*@__PURE__*/
  enumDesc(file_types, 4);

/**
 * @generated from enum types.PaymentTerm
 */
export enum PaymentTerm {
  /**
   * @generated from enum value: PAYMENT_TERM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Cash Against Documents
   *
   * @generated from enum value: PAYMENT_TERM_CAD = 1;
   */
  CAD = 1,

  /**
   * Cash In Advance
   *
   * @generated from enum value: PAYMENT_TERM_CIA = 2;
   */
  CIA = 2,

  /**
   * Cash Next Delivery
   *
   * @generated from enum value: PAYMENT_TERM_CND = 3;
   */
  CND = 3,

  /**
   * Cash On Delivery
   *
   * @generated from enum value: PAYMENT_TERM_COD = 4;
   */
  COD = 4,

  /**
   * End of Month
   *
   * @generated from enum value: PAYMENT_TERM_EOM = 5;
   */
  EOM = 5,

  /**
   * Letter of Credit
   *
   * @generated from enum value: PAYMENT_TERM_LOC = 6;
   */
  LOC = 6,

  /**
   * Net 5 days
   *
   * @generated from enum value: PAYMENT_TERM_NET5 = 7;
   */
  NET5 = 7,

  /**
   * Net 10 days
   *
   * @generated from enum value: PAYMENT_TERM_NET10 = 8;
   */
  NET10 = 8,

  /**
   * Net 15 days
   *
   * @generated from enum value: PAYMENT_TERM_NET15 = 9;
   */
  NET15 = 9,

  /**
   * Net 20 days
   *
   * @generated from enum value: PAYMENT_TERM_NET20 = 10;
   */
  NET20 = 10,

  /**
   * Net 30 days
   *
   * @generated from enum value: PAYMENT_TERM_NET30 = 11;
   */
  NET30 = 11,

  /**
   * Net 45 days
   *
   * @generated from enum value: PAYMENT_TERM_NET45 = 12;
   */
  NET45 = 12,

  /**
   * Net 60 days
   *
   * @generated from enum value: PAYMENT_TERM_NET60 = 13;
   */
  NET60 = 13,

  /**
   * Net 90 days
   *
   * @generated from enum value: PAYMENT_TERM_NET90 = 14;
   */
  NET90 = 14,

  /**
   * Payment In Advance
   *
   * @generated from enum value: PAYMENT_TERM_PIA = 15;
   */
  PIA = 15,

  /**
   * Due Upon Receipt
   *
   * @generated from enum value: PAYMENT_TERM_DUE_UPON_RECEIPT = 16;
   */
  DUE_UPON_RECEIPT = 16,
}

/**
 * Describes the enum types.PaymentTerm.
 */
export const PaymentTermSchema: GenEnum<PaymentTerm> = /*@__PURE__*/
  enumDesc(file_types, 5);

